'use strict';

module.exports = [
  PopoverService];

function PopoverService() {
  return {};
}



// WEBPACK FOOTER //
// ./src/js/core-components/popovers/PopoverService.js